enum popupName {
  registration = 'registration',
  anketa = 'anketa',
  anketaWebinar = 'anketaWebinar',
}

const AuthStatus = {
  NOT_AUTHORIZED: 1,
  AUTHORIZED: 2,
}

export { popupName, AuthStatus }
